import fetchAPI from '../fetchAPI';

export const callDeleteLicense = async (companyId: string): Promise<iResponse<User>> => {
  const response: iResponse<User> = await fetchAPI({
    method: `DELETE`,
    route: `company/${companyId}`
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callDeleteLicense;
